const mq = window.matchMedia('(max-width: 435px) and (orientation: portrait), (max-height: 435px) and (orientation: landscape)');

export const isMobile = () => {
  return mq.matches;
}

export const isMobileChange = (handler:any) => {
  mq.addListener(handler);
  return mq;
}